import { Component, EventEmitter, Input, OnDestroy, Output, inject } from '@angular/core'
import { Subject } from 'rxjs'
import { DataContextBuilder, ElderTableComponent, IDataContext, Sort } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { StorageNodeService } from '../storage-node.service'
import { StorageNode, StorageNodeType } from '../storage-node'
import { StorageNodeFilterBuilder } from '../storage-node-filter-builder'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatIcon } from '@angular/material/icon'

import { MatTooltip } from '@angular/material/tooltip'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-storage-node-table',
  templateUrl: './storage-node-table.component.html',
  styleUrls: ['./storage-node-table.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatTooltip,
    MatIcon,
    ElderTranslatePipe,
  ],
})
export class StorageNodeTableComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly destroy$ = new Subject<void>()

  public readonly data: IDataContext<StorageNode>

  public readonly StorageNodeType = StorageNodeType

  @Output()
  public selectionSingleChange = new EventEmitter<StorageNode>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const storageNodeService = inject(StorageNodeService)
    this.data = DataContextBuilder.start<StorageNode>()
      .pageSize(30)
      .autoStartOnFiltersAll([StorageNodeFilterBuilder.IDS_KEY], [new Sort('priority', 'asc')])
      .build(storageNodeService)
  }

  /***************************************************************************
   *                                                                         *
   * Lifecycle                                                               *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()

    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set storageNodeIds(nodeIds: string[]) {
    if (nodeIds && nodeIds.length > 0) {
      this.data.filter.updateFilter(StorageNodeFilterBuilder.ids(...nodeIds))
    } else {
      this.log.warn('Empty nodeIds filter given!')
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onSingleSelection(node: StorageNode): void {
    this.selectionSingleChange.next(node)
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  reload(): void {
    if (this.data) {
      this.data.reload()
    }
  }
}
